import React, { useEffect, useMemo, useState } from "react";
import { Button } from "react-bootstrap";
import { IoIosPaper } from "react-icons/io";
import Cookies from "js-cookie";
import moment from "moment";
import qs from "qs";

import {
  AxiosCustomGet,
  AxiosCustomPost,
  AxiosCustomPut,
} from "../../../../components/axios/AxiosCustom";
import Config from "../../../../components/axios/Config";
import CustomDatePicker from "../../../../components/common/DatePicker/CustomDatePicker";
import CustomTable from "../../../../components/common/Table/CustomTable";
import TextInput from "../../../../components/common/TextInput/TextInput";
import Title from "../../../../components/common/Title/Title";
import Breadcrumb from "../../../../components/common/Breadcrumb/Breadcrumb";
import ExportButton from "../../components/ExportButton";
import AddRefundDialog from "./components/AddRefundDialog";
import PreviewImage from "../../../../components/common/PreviewImage/PreviewImage";

import { convertBankList } from "../../../../components/helpers/convertBankList";
import SwalToast from "../../../../components/helpers/SwalToast";

import {
  addRefundInitData,
  refundInitFilterInput,
  renderRefundRequestColumns,
} from "../constants";

import "../../styles.css";
import { convertRefundRequest } from "../helpers";

const RefundRequest = () => {
  const [pageSizeValue, setPageSizeValue] = useState(10);
  const [searchNameValue, setSearchNameValue] = useState("");
  const [dateValue, setDateValue] = useState([]);
  const [refundList, setRefundList] = useState([]);
  const [filterInput, setFilterInput] = useState(refundInitFilterInput);
  const [loading, setLoading] = useState(false);
  const [tablePagination, setTablePagination] = useState({});
  const [totalTransactions, setTotalTransactions] = useState(0);
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [addData, setAddData] = useState(addRefundInitData);
  const [errors, setErrors] = useState({});
  const [transferProofImg, setTransferProofImg] = useState([]);
  const [approvalProofImg, setApprovalProofImg] = useState([]);
  const [imgLink, setImgLink] = useState("");
  const [bankList, setBankList] = useState([]);
  const [detailListRefund, setDetailListRefund] = useState();

  const getBankList = () => {
    setLoading(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}bank`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setLoading(false);
        setBankList(convertBankList(response.data.data));
      }
    );
  };

  const getRefundRequestList = () => {
    setLoading(true);
    const data = {
      search: filterInput.searchName,
      start_date_transaction: filterInput.transactionStartDate,
      end_date_transaction: filterInput.transactionEndDate,
      page: parseInt(filterInput.page),
      size: parseInt(filterInput.pageSize),
      sorting_field: filterInput.sortingField,
      sorting_order: filterInput.sortingOrder,
      status: "waiting",
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}refund/request`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      ),
      (response) => {
        setLoading(false);

        setTotalTransactions(response.data.data.total_item);
        setRefundList(
          convertRefundRequest(response.data.data.items, handleOpenPreview)
        );
        setTablePagination({
          current: response.data.data.page,
          pageSize: response.data.data.per_page,
          total: response.data.data.total_item,
        });
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data transaksi: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleTextInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "pageSize") {
      setPageSizeValue(value);
    } else if (name === "searchName") {
      setSearchNameValue(value);
    }
  };

  const handleDialogInputChange = (field, value) => {
    setAddData((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: null,
      }));
    }
  };

  const dataPdf = useMemo(() => {
    const temp = refundList.map(
      ({ transferProof, approvalProof, ...item }) => item
    );
    return temp;
  }, [refundList]);

  const handleEnter =
    (type = "enter") =>
      (event) => {
        const { name, value } = event.target;

        if (event.keyCode === 13 || type === "blur") {
          if (name === "pageSize" && value === "") {
            setPageSizeValue(10);
          }
          setFilterInput((prev) => ({
            ...prev,
            [name]: name === "pageSize" && value === "" ? 10 : value,
            page: 1,
          }));
        }
      };

  const handleDateChange = (event) => {
    const startDate = moment(event?.[0]?._d).startOf("day");
    const endDate = moment(event?.[1]?._d).startOf("day");
    setDateValue(event ? [startDate, endDate] : null);
    setFilterInput((prev) => ({
      ...prev,
      transactionStartDate: event ? new Date(startDate) : null,
      transactionEndDate: event ? new Date(endDate) : null,
      page: 1,
    }));
  };

  const handleSelectChange = (field, data) => {
    if (field === "bankName") {
      setAddData((prev) => ({
        ...prev,
        [field]: {
          value: data.value,
          label: data.label,
        },
      }));
    }

    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: null,
      }));
    }
  };

  const handleExport = (type) => (e) => {
    if (type === "excel") {
      handleExportExcel();
    }
  };

  const handleExportExcel = () => {
    const data = {
      search: filterInput.searchName,
      start_date_transaction: filterInput.transactionStartDate,
      end_date_transaction: filterInput.transactionEndDate,
      page: parseInt(filterInput.page),
      size: parseInt(filterInput.pageSize),
      sorting_field: filterInput.sortingField,
      sorting_order: filterInput.sortingOrder,
      status: "waiting",
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}report/refund/excel`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
          "content-type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
        "blob"
      ),
      (response) => {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "pengembalian_dana.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal export data menjadi excel: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleOpenAddDialog = (record) => {
    setDetailListRefund(record);
    setIsAddDialogOpen(true);
  };

  const handleOpenPreview = (src) => () => {
    setImgLink(src);
    setIsPreviewOpen(true);
  };

  const handleCancel = () => {
    setIsAddDialogOpen(false);

    if (errors) {
      setErrors({});
    }
  };

  const handleUploadImage = (type) => (options) => {
    const { onSuccess, onError, file } = options;

    const fmData = new FormData();
    fmData.append("file", file);

    let url = `${process.env.REACT_APP_BASE_API_URL}upload-image`;
    AxiosCustomPost(
      url,
      fmData,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
        "content-type": "multipart/form-data",
      }),
      (response) => {
        onSuccess(response.data.data, file);
        setAddData((prev) => ({
          ...prev,
          transferProof:
            type === "transferProof"
              ? response.data.data.object_path
              : prev.transferProof,
          approvalProof:
            type === "approvalProof"
              ? response.data.data.object_path
              : prev.approvalProof,
        }));
      },
      (error) => {
        onError({ error });
      }
    );
  };

  const handleImageChange =
    (type) =>
      ({ fileList }) => {
        let tempFileList = [...fileList];
        tempFileList = tempFileList.slice(-1);

        tempFileList = tempFileList.map((file) => {
          if (file.response) {
            file.url = file.response.url;
          }
          return file;
        });
        if (type === "transferProof") {
          setTransferProofImg(tempFileList);
        } else if (type === "approvalProof") {
          setApprovalProofImg(tempFileList);
        }
        if (errors[type]) {
          setErrors((prev) => ({
            ...prev,
            [type]: null,
          }));
        }
      };

  const validate = (data) => {
    const newErrors = {};

    if (!data.bankName || data.bankName === "") {
      newErrors.bankName = "Bank harus dipilih";
    }
    if (!data.accountNumber || data.accountNumber === "") {
      newErrors.accountNumber = "Nomor rekening tidak boleh kosong";
    }
    if (!data.accountName || data.accountName === "") {
      newErrors.accountName = "Nama rekening tidak boleh kosong";
    }
    if (!data.transferProof || data.transferProof === "") {
      newErrors.transferProof = "Bukti transfer harus diupload";
    }
    if (!data.approvalProof || data.approvalProof === "") {
      newErrors.approvalProof = "Bukti persetujuan harus diupload";
    }
    return newErrors;
  };

  const handleAdd = () => {
    const newErrors = validate(addData);

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      const data = {
        gadai_code: detailListRefund.gadaiCode,
        bank_name: addData.bankName.label,
        bank_account_name: addData.accountName,
        account_number: addData.accountNumber,
        transfer_proof: addData.transferProof,
        approval_proof: addData.approvalProof,
      };

      let url = `${process.env.REACT_APP_BASE_API_URL}refund/request/done`;

      console.log(data);
      AxiosCustomPut(
        url,
        data,
        Config({
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        }),
        () => {
          SwalToast.fire({
            icon: "success",
            title: "Berhasil memproses transaksi",
          });
        },
        (error) => {
          if (error.response) {
            SwalToast.fire({
              icon: "error",
              title: `Gagal memproses transaksi: ${error.response.data?.error?.message}`,
            });
          } else {
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        },
        () => {
          setIsAddDialogOpen(false);
          setAddData(addRefundInitData);
          setTransferProofImg([]);
          setApprovalProofImg([]);
          getRefundRequestList();
        }
      );
    }
  };

  const handleTableChange = (pagination, _, sorter) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      size: parseInt(pagination.pageSize),
      sortingField: sorter?.column?.backend_key || null,
      sortingOrder:
        sorter?.order === "ascend"
          ? "ASC"
          : sorter?.order === "descend"
            ? "DESC"
            : null,
    }));
  };

  const getMonthly = () => {
    let startOfMonth = moment().startOf("month");
    let endOfMonth = moment();

    setDateValue([startOfMonth, endOfMonth]);
    setFilterInput((prev) => ({
      ...prev,
      transactionStartDate: new Date(startOfMonth),
      transactionEndDate: new Date(endOfMonth),
    }));
  };

  useEffect(() => {
    getRefundRequestList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterInput]);

  useEffect(() => {
    getBankList();
    getMonthly();
  }, []);

  return (
    <div>
      <div className="px-3">
        <div className="py-4 d-flex">
          <div className="d-flex flex-column" style={{ fontSize: "13px" }}>
            <Title text={"Permintaan Pengembalian Dana"} />
            <Breadcrumb current={"Permintaan Pengembalian Dana"} />
          </div>
          <div className="ml-auto d-flex align-items-center">
            <div className="total-container">
              <IoIosPaper className="total-icon" />{" "}
              <span style={{ fontWeight: "bold" }}>{totalTransactions}</span>{" "}
              Transaksi
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between filter-bar-2">
          <TextInput
            id={"pageSize"}
            label={"Tampilkan"}
            width={"7%"}
            handleEnter={handleEnter}
            value={pageSizeValue}
            handleChange={handleTextInputChange}
          />
          <TextInput
            id={"searchName"}
            label={"No. SBG / No. Kwitansi / Nama Nasabah"}
            width={"30%"}
            placeholder={"Cari.."}
            handleEnter={handleEnter}
            value={searchNameValue}
            handleChange={handleTextInputChange}
          />
          <CustomDatePicker
            id={"capitalTransaction"}
            label={"Tanggal Transaksi"}
            isRangePicker
            width="20%"
            onInputChange={handleDateChange}
            value={dateValue}
          />
          <div className="ml-auto d-flex align-items-center">
            {/* <Button
              variant="primary"
              className="btn-action btn-add"
              onClick={handleOpenAddDialog}
            >
              + Tambah Transaksi
            </Button> */}
          </div>
        </div>

        <CustomTable
          columns={renderRefundRequestColumns(handleOpenAddDialog)}
          // scrollX={2000}
          data={refundList}
          loading={loading}
          handleTableChange={handleTableChange}
          pagination={tablePagination}
        />

        {/* <div className="filter-bar-2 d-flex " style={{ marginTop: "2rem" }}>
          <ExportButton
            handleExport={handleExport}
            pathname="/report/refund/export"
            data={dataPdf}
            from="report"
            columns={renderRefundColumns(null, null, false)}
          />
        </div> */}
      </div>

      <AddRefundDialog
        dataDetail={detailListRefund}
        visible={isAddDialogOpen}
        handleCancel={handleCancel}
        handleSave={handleAdd}
        actionButtonText={"Kirim"}
        title={`Proses Pengembalian Dana`}
        onInputChange={handleDialogInputChange}
        onSelectChange={handleSelectChange}
        errors={errors}
        data={addData}
        bankOptions={bankList}
        onImageChange={handleImageChange}
        handleUploadImage={handleUploadImage}
        transferProofImg={transferProofImg}
        approvalProofImg={approvalProofImg}
      />

      <PreviewImage
        visible={isPreviewOpen}
        setVisible={setIsPreviewOpen}
        url={imgLink}
      />
    </div>
  );
};

export default RefundRequest;
